import { handleActions } from 'redux-actions'
import {
  hasError,
  isLoading,
  data,
  setDataUrlRenovaciones,
  setDataServicios,
  setServiciosIsLoading,
  setServiciosHasError,
} from '../actions/aMenus';


export const datosProductosMenu =  handleActions(
  {
    [isLoading]: (state) => { return { ...state, isLoading: true, hasError: '' }; },
    [hasError]: (state,action) => ({ ...state, hasError: action.payload, isLoading: false, data: [] }),
    [data]: (state, action) => ({ ...state, isLoading: false, data: action.payload, date: new Date() }),
    [setDataUrlRenovaciones]: (state, action) => ({ ...state, setDataUrlRenovaciones: action.payload})
  },
  {
    isLoading: false,
    hasError: '',
    data: [],
    date: '',
    setDataUrlRenovaciones:''
  }
);

export const rServicios = handleActions(
  {
    [setDataServicios]: (state, action) => ({ ...state, serviciosIsLoading: false, dataServicios: action.payload, date: new Date() }),
    [setServiciosIsLoading]: (state) => { return { ...state, serviciosIsLoading: true, serviciosHasError: '' }; },
    [setServiciosHasError]: (state,action) => ({ ...state, serviciosHasError: action.payload, serviciosIsLoading: false, dataServicios: [] }),
  },
  {
    dataServicios: [],
    serviciosIsLoading: false,
    serviciosHasError: '',
    date: '',
  }
);